import { render, staticRenderFns } from "./ShopProductsAdmin.vue?vue&type=template&id=d935e064&"
import script from "./ShopProductsAdmin.vue?vue&type=script&lang=js&"
export * from "./ShopProductsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports